import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { segmentKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const PAGE_SIZE = 200;
const useAllSegments = () => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: segmentKeys.allForPicker(),
        queryFn: async () => {
            const segments = [];
            let offset = 0;
            let totalCount = 0;
            do {
                const response = await axios.get(markUrl('segments/list/'), {
                    ...additional,
                    params: { offset, limit: PAGE_SIZE }
                });
                const page = response.data.segments;
                segments.push(...page);
                totalCount = response.data.total_count;
                offset += page.length;
                if (page.length === 0)
                    break;
            } while (segments.length < totalCount);
            return segments;
        },
        staleTime: 30_000
    });
};
export default useAllSegments;
